/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusKundeCategoryEnum } from '../../models/lexplus-kunde-category-enum';
import { LexplusKundeListResponseDto } from '../../models/lexplus-kunde-list-response-dto';

export interface KundenControllerFindAllPaginatedV1$Params {

/**
 * Lists the Kunden of these Kategorien; an explicit `filter.status` narrows the list further.
 */
  category?: Array<LexplusKundeCategoryEnum>;

/**
 * Page number to retrieve. If you provide invalid value the default page number will applied
 *
 * **Example:** 1
 *
 *
 * **Default Value:** 1
 */
  page?: number;

/**
 * Number of records per page.
 *
 *
 * **Example:** 20
 *
 *
 *
 * **Default Value:** 25
 *
 *
 *
 * **Max Value:** 100
 *
 *
 * If provided value is greater than max value, max value will be applied.
 */
  limit?: number;

/**
 * Filter by status query param.
 *
 * **Format:** filter.status={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.status=$eq:John Doe&filter.status=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.status'?: Array<string>;

/**
 * Filter by contractStatus query param.
 *
 * **Format:** filter.contractStatus={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.contractStatus=$eq:John Doe&filter.contractStatus=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.contractStatus'?: Array<string>;

/**
 * Filter by projektleiterID query param.
 *
 * **Format:** filter.projektleiterID={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.projektleiterID=$eq:John Doe&filter.projektleiterID=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.projektleiterID'?: Array<string>;

/**
 * Parameter to sort by.
 * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
 *
 * **Format:** {fieldName}:{DIRECTION}
 *
 *
 * **Example:** sortBy=letzteAktualisierung:DESC&sortBy=kundeID:DESC
 *
 *
 * **Default Value:** letzteAktualisierung:DESC
 *
 * **Available Fields**
 * - letzteAktualisierung
 *
 * - kundeID
 *
 * - status
 *
 * - contractStatus
 *
 * - auftragsvolumen
 *
 * - projektleiter.nachname
 *
 * - name
 */
  sortBy?: Array<'letzteAktualisierung:ASC' | 'letzteAktualisierung:DESC' | 'kundeID:ASC' | 'kundeID:DESC' | 'status:ASC' | 'status:DESC' | 'contractStatus:ASC' | 'contractStatus:DESC' | 'auftragsvolumen:ASC' | 'auftragsvolumen:DESC' | 'projektleiter.nachname:ASC' | 'projektleiter.nachname:DESC' | 'name:ASC' | 'name:DESC'>;

/**
 * Search term to filter result values
 *
 * **Example:** John
 *
 *
 * **Default Value:** No default value
 */
  search?: string;

/**
 * List of fields to search by term to filter result values
 *
 * **Example:** 
 *
 *
 * **Default Value:** By default all fields mentioned below will be used to search by term
 *
 * **Available Fields**
 */
  searchBy?: Array<string>;

/**
 * List of fields to select.
 *
 * **Example:** kundeID,name,projectNumberUpdate,beschreibung,status
 *
 *
 * **Default Value:** By default all fields returns. If you want to select only some fields, provide them in query param
 */
  select?: string;
}

export function kundenControllerFindAllPaginatedV1(http: HttpClient, rootUrl: string, params?: KundenControllerFindAllPaginatedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusKundeListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, kundenControllerFindAllPaginatedV1.PATH, 'get');
  if (params) {
    rb.query('category', params.category, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.status', params['filter.status'], {});
    rb.query('filter.contractStatus', params['filter.contractStatus'], {});
    rb.query('filter.projektleiterID', params['filter.projektleiterID'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
    rb.query('select', params.select, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusKundeListResponseDto>;
    })
  );
}

kundenControllerFindAllPaginatedV1.PATH = '/v1/kunden/paginated';
